import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ThemeScope } from 'src/app/core/theme/theme-scope';

/** Themed mat-card shell. Prefer app-card-table for list+table pages. */
@Component({
  selector: 'app-theme-card',
  templateUrl: './theme-card.component.html',
  styleUrls: ['./theme-card.component.scss'],
})
export class ThemeCardComponent {
  /** Feature scope for Experience token cascade. */
  @Input() themeScope: ThemeScope | string | null = null;
  /** When true, applies .card-overflow. */
  @Input() overflow = false;
  /** Adds flex-100 on the inner mat-card. Set false for flex-30/40/etc. */
  @Input() fullWidth = true;
  /** When false, skips .card-shadow. */
  @Input() applyShadow = true;
  /** Host uses display:contents so layout matches a bare mat-card. */
  @Input() passthroughLayout = true;
  @Input() cardClass: string | string[] | Set<string> | { [klass: string]: any } | null = null;
  @Input() cardStyle: { [klass: string]: any } | null = null;
  @Output() cardClick = new EventEmitter<MouseEvent>();

  @HostBinding('class.theme-card--passthrough')
  get hostPassthrough(): boolean {
    return this.passthroughLayout;
  }
}
